import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import Dialog from '@material-ui/core/Dialog'

import { Colors } from '../../../styles'

export const TooltipsWrapper = styled.div`
  z-index: 1000;
  transform: rotate(${(props) => props.deg}deg);
`

export const Box = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`

export const Tooltips = styled(ReactTooltip)`
  min-width: 175px;
`

export const TittleTooltips = styled.span`
  color: ${Colors.grey};
`

export const ContentTooltips = styled.div`
  padding-left: 10px;
  color: ${Colors.black};
`

export const Jetty = styled.div`
  position: absolute;
  width: 22%;
  height: 15%;
  top: ${(props) => props.top}; // e.g. '22%'
  left: ${(props) => props.left}; // e.g. '64%'
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transform: rotate(${(props) => props.rotate || '0deg'});
  z-index: 2;

  &:hover {
    z-index: 3;
  }
`

export const Vessel = styled.img`
  width: ${(props) => props.width || 'auto'};
  height: ${(props) => props.height || '100%'}; // e.g. '100%', '80%', '60%'
  transform: rotate(${(props) => props.rotate || '0deg'});
  transform-origin: bottom center;
`
export const TOJContainer = styled.div`
  position: absolute;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-direction: column-reverse;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  z-index: 1000;
  transform: ${({ isDolphin }) =>
  `translateX(-50%) rotate(${isDolphin ? '0deg' : '-90deg'}) scale(1)`};
  top: ${({ isDolphin }) => (isDolphin ? '-7.90rem' : '')};
`

export const TOJItem = styled.div`
  width: 100%;
  height: 3.75rem;
  display: flex;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 999px;
  align-items: center;
  justify-content: start;
  border: 1px solid ${Colors.white};
  background-color: ${Colors.white};
  transform: scale(1) !important;
`
export const TOJInfoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 3.65rem;
  display: flex;
  align-items: center;
`
export const TOJItemFilled = styled.div`
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  position: absolute;
  border-radius: inherit;
  transition: width 0.3s ease;
  background-color: ${Colors.topaz};
  width: ${(props) => props.percentage || 0}%;
`
export const TOJCircleWrapper = styled.div`
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
  background-color: ${(props) =>
    props.percentage ? Colors.topaz : Colors.white};
`

export const TOJItemFillWrapper = styled.div`
  position: absolute;
  inset: 0px 0px 0px 0px;
  width: 100%;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
`
export const TOJCirclePercentage = styled.div`
  width: 3.65rem;
  height: 3.65rem;
  display: flex;
  font-size: 1rem; /* Ukuran font tetap */
  cursor: inherit;
  font-weight: 800;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid ${Colors.white};
  background-color: ${Colors.najavoWhite};
`
export const TOJDescription = styled.div`
  z-index: 1;
  display: flex;
  cursor: inherit;
  padding: 0px 2px 0px 2px;
  flex-direction: column;
  justify-content: start;
`

export const TOJValueWrapper = styled.div`
  display: flex;
  cursor: inherit;
  align-items: center;
  justify-content: start;
`

export const TOJName = styled.label`
  font-size: 0.8rem;
  cursor: inherit;
  max-width: 5rem;
  font-weight: 700;
  color: ${Colors.black};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
export const TOJMaxValue = styled.label`
  font-size: 0.8rem;
  cursor: inherit;
  font-weight: 700;
  color: ${Colors.black};
`
export const TOJValue = styled.label`
  font-size: 0.8rem;
  cursor: inherit;
  font-weight: 600;
  color: ${Colors.black};
`

export const Modal = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 8px;
    max-width: 580px;
    border: 1px solid ${Colors.white};
  }
`

export const ModalHeader = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${Colors.softBlue};
`
export const ModalTitle = styled.label`
  color: ${Colors.white};
  font-weight: 700;
  font-size: 20px;
`
export const ModalTOJName = styled.div`
  font-weight: 700;
  font-size: 16px;
  padding: 8px 24px;
  color: ${Colors.softBlue};
  background-color: #f5f5f5;
`

export const ModalContent = styled.div`
  gap: 8px;
  display: flex;
  overflow-y: auto;
  max-height: 40rem;
  padding: 16px 24px;
  flex-direction: column;
  background-color: ${Colors.white};
`
export const FormContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`
export const FormWrapper = styled.div`
  flex: 1;
`
export const ItemWrapper = styled.div`
  gap: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
`
export const ProgressItem = styled.div`
  width: 100%;
  display: flex;
  padding: 6px 24px;
  border-radius: 8px;
  background-color: #e8e8e8;
  justify-content: space-between;
`
export const Label = styled.label`
  font-weight: 600;
  font-size: 14px;
  color: ${Colors.cancelTextColor};
`
export const Percentage = styled.label`
  font-weight: 700;
  font-size: 14px;
  color: ${Colors.softBlue};
`
export const CloseButton = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  outline: none;
`

/* ── RenderTOJNew components ── */
export const TOJNewItem = styled.div`
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.35rem 0.3rem;
  border-radius: 10px;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.white};
  box-sizing: border-box;
`

export const TOJNewPercentageBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
  background-color: ${Colors.najavoWhite};
  border: 2px solid ${({ percentage }) => percentage > 0 ? Colors.topaz : Colors.white};
`

export const TOJNewPercentageText = styled.span`
  font-size: 0.75rem;
  font-weight: 800;
  color: ${Colors.black};
`

export const TOJNewProductType = styled.label`
  font-size: 0.7rem;
  font-weight: 700;
  cursor: pointer;
  color: ${Colors.black};
  width: 100%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TOJNewVolumeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
`

export const TOJNewVolumeText = styled.span`
  font-size: 0.68rem;
  font-weight: 600;
  color: ${Colors.black};
  cursor: pointer;
`

export const TOJNewProgressTrack = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #e0e0e0;
  overflow: hidden;
  margin-top: 0.1rem;
`

export const TOJNewProgressFill = styled.div`
  height: 100%;
  border-radius: 2px;
  background-color: ${Colors.topaz};
  width: ${({ percentage }) => percentage || 0}%;
  transition: width 0.3s ease;
`

/* ── RenderTOJNew Large (redesigned) components ── */
export const TOJNewItemLg = styled.div`
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  padding: 0.5rem 0.4rem;
  border-radius: 10px;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.white};
  box-sizing: border-box;
`

export const TOJNewPercentageBoxLg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background-color: ${({ percentage }) =>
    percentage >= 100
      ? '#e8f8f0'
      : percentage >= 67
      ? '#e8f4ff'
      : percentage >= 34
      ? '#fff8e8'
      : '#fff0f0'};
  border: 3px solid
    ${({ percentage }) =>
      percentage >= 100
        ? '#2ecc71'
        : percentage >= 67
        ? Colors.topaz
        : percentage >= 34
        ? '#f1c40f'
        : '#e74c3c'};
`

export const TOJNewPercentageTextLg = styled.span`
  font-size: 1rem;
  font-weight: 800;
  color: ${Colors.black};
`

export const TOJNewProductTypeLg = styled.label`
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  color: ${Colors.black};
  width: 100%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TOJNewVolumeTextLg = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${Colors.black};
  cursor: pointer;
`

export const TOJNewProgressTrackLg = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background-color: #e0e0e0;
  overflow: hidden;
  margin-top: 0.1rem;
`

export const TOJNewProgressFillLg = styled.div`
  height: 100%;
  border-radius: 3px;
  width: ${({ percentage }) => percentage || 0}%;
  transition: width 0.3s ease;
  background-color: ${({ percentage }) =>
    percentage >= 100
      ? '#2ecc71'
      : percentage >= 67
      ? Colors.topaz
      : percentage >= 34
      ? '#f1c40f'
      : '#e74c3c'};
`

/* ── RenderTOJNew Card (transparent / no-background) components ── */
const _cardProgressColor = ({ percentage }) =>
  percentage >= 100
    ? '#2ecc71'
    : percentage >= 67
    ? Colors.topaz
    : percentage >= 34
    ? '#f1c40f'
    : '#e74c3c'

export const TOJCardItem = styled.div`
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.4rem 0.3rem;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  &:last-child {
    border-bottom: none;
  }
`

export const TOJCardRing = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.4rem;
  height: 3.4rem;
  border-radius: 50%;
  border: 3px solid ${_cardProgressColor};
  background-color: transparent;
  box-shadow: 0 0 6px ${_cardProgressColor};
`

export const TOJCardPercentageText = styled.span`
  font-size: 0.95rem;
  font-weight: 800;
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
`

export const TOJCardProductType = styled.label`
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  width: 100%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TOJCardVolumeText = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  cursor: pointer;
`

export const TOJCardProgressTrack = styled.div`
  width: 100%;
  height: 5px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.35);
  overflow: hidden;
  margin-top: 0.1rem;
`

export const TOJCardProgressFill = styled.div`
  height: 100%;
  border-radius: 3px;
  width: ${({ percentage }) => percentage || 0}%;
  transition: width 0.3s ease;
  background-color: ${_cardProgressColor};
`

/* ── RenderTOJNew Pill (dark semi-transparent) components ── */
const _pillProgressColor = ({ percentage }) =>
  percentage >= 100
    ? '#2ecc71'
    : percentage >= 67
    ? Colors.topaz
    : percentage >= 34
    ? '#f1c40f'
    : '#e74c3c'

export const TOJPillItem = styled.div`
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.28rem;
  padding: 0.45rem 0.4rem;
  border-radius: 10px;
  box-sizing: border-box;
  background: rgba(10, 18, 38, 0.68);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
`

export const TOJPillRing = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
  border: 3px solid ${_pillProgressColor};
  box-shadow: 0 0 8px ${_pillProgressColor};
`

export const TOJPillPercentageText = styled.span`
  font-size: 1.15rem;
  font-weight: 800;
  color: #ffffff;
`

export const TOJPillProductType = styled.label`
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  color: #ffffff;
  width: 100%;
  text-align: center;
  word-break: break-word;
  white-space: normal;
`

export const TOJPillVolumeText = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
`

export const TOJPillDivider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
  margin: 0.05rem 0;
`

export const TOJPillProgressTrack = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.15);
  overflow: hidden;
`

export const TOJPillProgressFill = styled.div`
  height: 100%;
  border-radius: 3px;
  width: ${({ percentage }) => percentage || 0}%;
  transition: width 0.3s ease;
  background-color: ${_pillProgressColor};
`

export const TOJBarItem = styled.div`
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0.4rem;
  padding: 0.5rem 0.35rem;
  box-sizing: border-box;
  padding-left: 0.6rem;
`

export const TOJBarContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  padding-right: 1.3rem;
`

export const TOJBarRing = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background: rgba(10, 18, 38, 0.5);
  border: 0.1875rem solid ${_pillProgressColor};
  box-shadow: 0 0 0.5rem ${_pillProgressColor};
`

export const TOJBarPercentageText = styled.span`
  font-size: 1.3rem;
  font-weight: 800;
  color: #ffffff;
`

export const TOJBarProductType = styled.label`
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  color: #ffffff;
  width: 100%;
  text-align: center;
  word-break: break-word;
  white-space: normal;
  line-height: 1.3;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.85);
`

export const TOJBarVolumeText = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.75);
  cursor: pointer;
  white-space: nowrap;
`

export const TOJBarTrack = styled.div`
  flex-shrink: 0;
  width: 0.8125rem;
  border-radius: 0.3125rem;
  background-color: rgba(0, 0, 0, 0.55);
  border: 0.09375rem solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column-reverse;
  overflow: hidden;
`

export const TOJBarFill = styled.div`
  width: 100%;
  height: ${({ percentage }) => percentage || 0}%;
  transition: height 0.4s ease, background-color 0.4s ease;
  background-color: ${_pillProgressColor};
`

// Morowali map (BerthMorowali.svg, viewBox 1454x720). The stage has the same
// aspect ratio as the SVG so every SVG coordinate maps 1:1 to a percentage.
// The map always covers the full screen width (at least as wide as 88.72vh
// tall); on short screens the bottom of the map is cropped instead.
export const MOROWALI_MAP_WIDTH = 'max(100vw, calc(88.72vh * 1454 / 720))'

export const MapStage = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  width: ${MOROWALI_MAP_WIDTH};
  aspect-ratio: 1454 / 720;
  pointer-events: none;
`

export const MapStageSvg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`

export const TOJSlotContainer = styled.div`
  position: absolute;
  left: ${({ left }) => left};
  top: ${({ top }) => top};
  width: ${({ width }) => width || '10rem'};
  z-index: 1000;
  pointer-events: auto;
  transform: translate(-50%, -50%) scale(0.72);
`

export const DummyBadge = styled.div`
  position: absolute;
  top: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-weight: 700;
  color: #ffffff;
  background: rgba(220, 68, 59, 0.9);
  z-index: 1001;
`

// "Fuel Bunker Not Available" tag: horizontally centred between the right edge
// of the side panel (left 1.5626vw + width 19.27vw) and the west edge of the pier
// (x = 388.5 in the 1454 wide map), so it never touches the panel or the pier.
// Positions are relative to the map stage, which is MOROWALI_MAP_WIDTH wide and
// right-aligned on the screen.
export const FuelBunkerNotAvailableTag = styled.div`
  position: absolute;
  top: ${(490.5 / 720) * 100}%;
  left: max(
    calc((20.83vw - (100vw - ${MOROWALI_MAP_WIDTH}) + ${MOROWALI_MAP_WIDTH} * 388.5 / 1454) / 2),
    calc(20.83vw - (100vw - ${MOROWALI_MAP_WIDTH}) + 4rem)
  );
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 0.25rem 0.6rem;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
  color: #ffffff;
  background: rgba(95, 107, 115, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.6);
  line-height: 1.25;
  font-size: 0.75rem;

  strong {
    display: block;
    font-weight: 700;
    font-size: 0.8rem;
  }
`
